export const availableCountries = ["POL", "DEU", "AUT"];

const Config = {
  availableCountries
};

export default Config;
